import type { Country } from "../types/country";
import type { FieldOption } from "../types/form";

// import { getApplicationLanguage } from "./storage";

const localCountry = "SE"; // read from setting in the future
const currentLanguage = "sv"; // read from setting in the future

export const convertCountriesToSelectOptions = (countries: Array<Country>): Array<FieldOption> =>
	countries.map((country) => ({
		value: country.alpha2Code,
		label: country.names[currentLanguage],
	}));

export const excludeLocalCountry = (countries: Array<Country>) =>
	countries.filter((c) => c.alpha2Code !== localCountry);
